import { actions } from "./reducer";
import store from "./store";

export function selectTab (tab: string) {
    store.dispatch(actions.activeTab(tab))
}